/**
 * Created by phatbass on 2/9/16.
 */

angular.module('far.search')
    .controller('SearchClubController', function ($log, $http, form, formsUtils) {
        var vm = {
            loaded: true,
            submitted: false,
            form: {},
            current: {
                offset: 0,
                limit: 30,
                count: '',
                data: []
            },
            total: {
                count: 0,
                pages: null
            },
            formSearchClub: form('formSearchClub'),
            submit: function ( next ) {
                if (vm.submitted) {
                    return false;
                }

                if ( !next ) {
                    vm.current.offset = 0;
                    vm.current.data = [];
                    vm.total.count = 0;
                    vm.total.pages = null;
                }

                var data = angular.merge({}, vm.form);
                if(1 > Object.keys(data).length){
                    if('' !== window.location.hash){
                        data = JSON.parse(decodeURIComponent(atob(window.location.hash.substring(1))));
                    }
                }
                this.data = data;
                window.location.hash = btoa(encodeURIComponent(JSON.stringify(data)));

                if ( angular.isObject( data.member ) ) {
                    data.member = data.member.id;
                }

                if ( angular.isObject( data.qualification ) ) {
                    data.qualification = data.qualification.id;
                }

                if ( angular.isObject( data.achievements ) ) {
                    data.achievements = data.achievements.id;
                }

                data['offset'] = vm.current.offset;
                data['limit'] = vm.current.limit;
                data['subclub'] = false;

                vm.submitted = true;

                $http.get(Routing.generate('api_club_search', data)).then(function (response) {
                    vm.total.count = response.headers('X-Total-Count');
                    vm.total.pages = Math.ceil( vm.total.count / vm.current.limit );

                    for ( var id in response.data ) {
                        response.data[ id ]['url'] = Routing.generate('club_members', {id: response.data[id].id});

                        if ( response.data[ id ].users.length ) {
                            response.data[ id ].users = response.data[ id ].users.map(function(user) {
                                user['url'] = Routing.generate('user_view', {userId: user.id});

                                return user;
                            });
                        }

                        vm.current.data.push( response.data[ id ] );
                    }

                    vm.current.count = 'Региональные федерации альпинизма';

                    vm.submitted = false;
                }, function errorCallback(response) {
                    $log.error(response);

                    vm.submitted = false;
                });
            },
            next: function () {
                vm.current.offset += vm.current.limit;

                vm.submit( true );
            },
            getTotalCount: function () {
                return vm.current.count;
            }
        };



        vm.submit();

        return vm;
    });
